import React from 'react';

export default function Wave3(props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			preserveAspectRatio="xMinYMid"
			viewBox="0 0 1200 120"
			fill="currentColor"
			aria-hidden="true"
			style={{ maxWidth: '100%', width: '100%', ...props.style }}
			preserveAspectRatio="none"
			{...props}
		>
			<path d="M1200,17.7V418H0V44.3L40,49c40,4.7,120,13.1,200,8.9c80-4.2,160-22.6,240-17.8c80,4.4,160,31,240,48.8c80,18.1,160,26.4,240,13.3c80-13.6,160-48.6,200-66.7L1200,17.7z"></path>
		</svg>
	);
}
